export default "__VITE_ASSET__D5iBFYIN__"